import { render, staticRenderFns } from "./HoverPopover.vue?vue&type=template&id=4c1480e6&scoped=true&"
import script from "./HoverPopover.vue?vue&type=script&lang=js&"
export * from "./HoverPopover.vue?vue&type=script&lang=js&"
import style0 from "./HoverPopover.vue?vue&type=style&index=0&id=4c1480e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1480e6",
  null
  
)

export default component.exports